import React from "react";
import { formatToZMW } from "../../../../helpers";

const ReportOfTheCouncil = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Report of the Council</h1>
   
    </div>
  );
};

const BackgroundAndLocation = () => {
  return (
    <div className="p-6 mt-6 border-t">
      <h2 className="text-xl font-bold">Background and Location of the Council</h2>
      <section className="mb-6">
        <p className="text-gray-800 leading-relaxed">
          <strong>[council name] Town Council</strong> was established and given
          district council status in <strong>July, 2012</strong>. It was
          delineated from Kawambwa District and is located in Kazembe along the
          valley of the Luapula River, on the northern part of Luapula Province.
          The town is approximately <strong>182 Km</strong> from the provincial
          capital, Mansa, and <strong>940 Km</strong> from the nation’s capital,
          Lusaka.
        </p>
      </section>

      {/* Geography */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-blue-800 mb-2">
          Geographic Location
        </h2>
        <p className="text-gray-800 leading-relaxed">
          The district is located between longitudes{" "}
          <strong>28º 30´ and 29º 0´ east</strong> of the Greenwich Meridian and
          latitudes <strong>9º 41´ and 10º 9´ south</strong> of the Equator. The
          rainfall pattern in the area supports farming activities for crops
          such as maize and cassava.
        </p>
        <p className="text-gray-800 leading-relaxed mt-2">
          It shares boundaries with:
        </p>
        <ul className="list-disc list-inside text-gray-700 mt-2 ml-4">
          <li>Nchelenge District in the north</li>
          <li>Mwense District in the south</li>
          <li>Democratic Republic of the Congo (west)</li>
          <li>Kawambwa District in the east</li>
        </ul>
        <p className="text-gray-800 leading-relaxed mt-2">
          The district covers an area of approximately{" "}
          <strong>1,200 km²</strong> (about 2.4% of Luapula Province), with only{" "}
          <strong>64 km²</strong> of state land and{" "}
          <strong>1,136 km²</strong> as customary land under the leadership of
          <strong> His Royal Highness Mwata Kazembe</strong>.
        </p>
      </section>

      {/* Cultural Heritage */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-blue-800 mb-2">
          Cultural Heritage
        </h2>
        <p className="text-gray-800 leading-relaxed">
          [council name] boasts a rich cultural heritage, most notably the{" "}
          <strong>Umutomboko traditional ceremony</strong>, held annually on the
          last Saturday of July. This event attracts thousands of local and
          international tourists, boosting the district’s economy.
        </p>
      </section>

      {/* Historical Background */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-blue-800 mb-2">
          Historical Background
        </h2>
        <p className="text-gray-800 leading-relaxed">
          The <strong>Kazembe Kingdom</strong> was established in the{" "}
          <strong>1740s</strong>. At its peak in the 1800s during the reign of{" "}
          <strong>Kazembe II, Kaniembo</strong>, the kingdom controlled vast
          territories, including parts of the Katanga region of Congo and
          northern Zambia. It became a hub for trade between the African
          interior and Portuguese and Arab traders along the eastern coast.
        </p>
      </section>

      {/* Population */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-blue-800 mb-2">
          Population and Settlements
        </h2>
        <p className="text-gray-800 leading-relaxed">
          The district has linear settlement patterns. According to the{" "}
          <strong>2022 Zambia Statistics Agency Census</strong>, the population
          reached <strong>58,919</strong>, with:
        </p>
        <ul className="list-disc list-inside text-gray-700 mt-2 ml-4">
          <li>30,375 females (52%)</li>
          <li>28,546 males (48%)</li>
        </ul>
        <p className="text-gray-800 leading-relaxed mt-2">
          This makes [council name] the <strong>8th most populous district</strong>{" "}
          in Luapula Province, with a population density of{" "}
          <strong>49 persons per km²</strong> — well above the national average
          of 17.4 and regional average of 19.6 persons per km². The population
          grew by an average of <strong>2.2% annually</strong>, from 45,294 in
          2010 to 58,919 in 2022.
        </p>
      </section>

      {/* Postal Address */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-blue-800 mb-2">
          Postal Address
        </h2>
        <p className="text-gray-800 leading-relaxed">
          <strong>The Civic Centre</strong>
          <br />
          P.O Box 750002
          <br />
          [town name]
          <br />
          <strong>[council name]</strong>
        </p>
      </section>
    </div>
  );
};

const CompositionOfTheCouncil = ({currentYearData, previousYearData, startDate}) => {

  const currentYear = startDate ? new Date(startDate).getFullYear() : new Date().getFullYear();
  const previousYear = currentYear - 1;
  return (
    <div className="p-6 mt-6 border-t">
      <h2 className="text-xl font-bold">Composition of the Council</h2>
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-blue-800 mb-2">
          Governance and Composition
        </h2>
        <p className="text-gray-800 leading-relaxed">
          [council name] Town Council is a corporate body established under{" "}
          <strong>Article 152</strong> of the Constitution of Zambia (Amendment) Act No. 2 of
          2016 and Section 6 of the Local Government Act No. 2 of 2019. It is
          mandated to provide service delivery and policy-making for the
          community.
        </p>
        <p className="text-gray-800 leading-relaxed mt-2">
          The Council consists of an elected Chairperson, twelve (12) elected
          Councillors representing each ward, and a Chief Representative as per{" "}
          <strong>Article 153 (2)(c)</strong> of the Constitution.
        </p>
      </section>

      {/* Leadership */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Leadership
        </h3>
        <ul className="list-disc list-inside text-gray-700">
          <li>
              Council Chairperson: <strong>[name]</strong> ([year]-
              [year])
          </li>
          <li>
            Vice Council Chairperson: Elected from Councillors in [year] (2.5-year term)
        
          </li>
        </ul>
      </section>

      {/* Wards and Councillors */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Wards and Councillors
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse border border-gray-300 rounded-lg shadow-sm">
            <thead className="bg-blue-950 text-white">
              <tr>
                <th className="px-4 py-2 text-left">S/N</th>
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">Gender</th>
                <th className="px-4 py-2 text-left">Position</th>
                <th className="px-4 py-2 text-left">Ward</th>
              </tr>
            </thead>
            <tbody className="text-gray-800">
              {[
                ["1", "John Doe", "Male", "Council Chairperson", "N/A"],
             
              ].map(([sn, name, gender, position, ward]) => (
                <tr key={sn} className="border-b border-gray-200">
                  <td className="px-4 py-2">{sn}</td>
                  <td className="px-4 py-2">{name}</td>
                  <td className="px-4 py-2">{gender}</td>
                  <td className="px-4 py-2">{position}</td>
                  <td className="px-4 py-2">{ward}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Member of Parliament */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Member of Parliament
        </h3>
        <p className="text-gray-800">
          <strong>Hon. [member of parliament name]</strong> [gender] — [council name]
          Constituency
        </p>
      </section>

      {/* Secretariat */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Council Secretariat
        </h3>
        <p className="text-gray-800 leading-relaxed">
          The secretariat is headed by the Council Secretary, supported by five
          (5) heads of departments: Finance, Planning, Works, Human Resource,
          and Administration. Procurement and Internal Audit units fall under
          the Administration department.
        </p>
      </section>

      {/* Functions */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Functions of the Council
        </h3>
        <p className="text-gray-800 leading-relaxed">
          The Council delivers public goods and services and exercises powers
          such as making by-laws, imposing fees and levies, and formulating
          local policies to guide development, in line with{" "}
          <strong>Article 147 (2)(c)</strong> of the Constitution and the Local
          Government Act.
        </p>
      </section>

      {/* Financial Results */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Financial Results
        </h3>
        <table className="w-full table-auto border-collapse border border-gray-300 rounded-lg shadow-sm mb-4">
          <thead className="bg-blue-950 text-white">
            <tr>
              <th className="px-4 py-2 text-left">Description</th>
              <th className="px-4 py-2 text-right">{currentYear}</th>
              <th className="px-4 py-2 text-right">{previousYear}</th>
            </tr>
          </thead>
          <tbody className="text-gray-800">
            {[
              ["Cash Receipts", `${formatToZMW(currentYearData.filter(a=>a.type==='income').reduce((sum, a)=>sum+parseFloat(a.amount), 0))}`, `${formatToZMW(previousYearData.filter(a=>a.type==='income').reduce((sum, a)=>sum+parseFloat(a.amount), 0))}`],
              ["Payments", `${formatToZMW(currentYearData.filter(a=>a.type==='expense').reduce((sum, a)=>sum+parseFloat(a.amount), 0))}`, `${formatToZMW(previousYearData.filter(a=>a.type==='expense').reduce((sum, a)=>sum+parseFloat(a.amount), 0))}`],
              [
                "Increase/Decrease in Cash and Cash Equivalents",
                `(${formatToZMW(currentYearData.filter(a=>a.type==='income').reduce((sum, a)=>sum+parseFloat(a.amount), 0) - currentYearData.filter(a=>a.type==='expense').reduce((sum, a)=>sum+parseFloat(a.amount), 0))})`,
                `(${formatToZMW(previousYearData.filter(a=>a.type==='income').reduce((sum, a)=>sum+parseFloat(a.amount), 0) - previousYearData.filter(a=>a.type==='expense').reduce((sum, a)=>sum+parseFloat(a.amount), 0))})`,
              ],
            ].map(([desc, y2024, y2023], i) => {
              return (
              <tr key={i} className="border-b border-gray-200">
                <td className="px-4 py-2">{desc}</td>
                <td className="px-4 py-2 text-right">{y2024}</td>
                <td className="px-4 py-2 text-right">{y2023}</td>
              </tr>
            )})}
          </tbody>
        </table>
      </section>

      {/* Employees */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">Employees</h3>
        <p className="text-gray-800 leading-relaxed">
          Employees increased from <strong>[number of employees at the start of the year]</strong> at the start of the year
          to <strong>[number of employees by year-end]</strong> by year-end. Total expenditure on employee
          remuneration and welfare was <strong>[remuneration amount]</strong>.
        </p>
      </section>

      {/* Compliance */}
      <section className="mb-6">
        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          Health, Safety, and Auditing
        </h3>
        <p className="text-gray-800 leading-relaxed">
          The Council ensures employee safety in compliance with the{" "}
          <strong>Occupational Health and Safety Act No. 36 of 2010</strong>.
          Audits are conducted by the Auditor-General as required by{" "}
          <strong>Article 250</strong> of the Constitution and{" "}
          <strong>Section 44(2)</strong> of the Local Government Act.
        </p>
      </section>

      {/* Signature */}
      <section className="mt-6">
        <p className="text-gray-800">
          By order of the Council
          <br />
          <strong>Signature: _____________________</strong>
          <br />
          Name: <strong>[name]</strong>
          <br />
          Position: <strong>Council Chairperson</strong>
          <br />
          Date: _______________________
        </p>
      </section>
    </div>
  );
};

const StatementOfResponsibilities = () => {
  return (
    <div className="p-6 mt-6 border-t">
      <h2 className="text-xl font-bold">STATEMENT OF RESPONSIBILITIES FOR ANNUAL FINANCIAL STATEMENTS</h2>
      <div className="space-y-4 text-gray-800 leading-relaxed">
        <p>
          The [council name] Town Council is responsible for preparing the financial statements for the
          year ended 31<sup>st</sup> December, 2023 which are free from material misstatement, whether
          due to fraud or error, and are prepared, in all material respects, in accordance with the Cash
          Basis International Public Sector Accounting Standard (IPSAS). In preparing the financial
          statements, the Council selected applicable policies from Amended Local Authorities Accounting
          Policies (LAAPs) No. 2 of 2022 and then applied them consistently, making judgment and estimates
          that were reasonable and prudent.
        </p>

        <p>
          The Council is also responsible for the maintenance of adequate accounting records and the
          preparation and integrity of the annual financial statements and related information. The
          Auditor-General has audited the financial statements and his report is shown on pages 6 to 8.
        </p>

        <p>
          The Council accepts responsibility for the annual financial statements, which have been prepared
          using appropriate accounting policies supported by reasonable estimates, in conformity with the
          Cash Basis IPSAS, the requirements of the Local Government Act No. 2 of 2019, the Public Finance
          Management Act No. 1 of 2018 and Amended Local Authorities Accounting Policies (LAAPs) No. 2 of
          2022.
        </p>

        <p>The Council further accepts responsibility:</p>
        <ul className="list-disc pl-6">
          <li>
            for the maintenance of accounting records that may be relied upon in the preparation of financial
            statements,
          </li>
          <li>
            for designing, implementing and maintaining systems of internal controls relevant to the
            preparation and fair presentation of financial statements that are free from material misstatement,
            whether due to fraud or error.
          </li>
        </ul>

        <p>
          Nothing has come to the attention of the Council to indicate that the [council name] Town Council
          will not remain a going concern for at least twelve months from the date of this statement.
        </p>

        <p>
          In the opinion of the Council, proper books of accounts were maintained to support preparation of
          Financial Statements that present fairly the financial results of the [council name] Town Council for
          the financial year ended 31<sup>st</sup> December, 2024.
        </p>
      </div>

      <div className="mt-10 space-y-8">
        <p>Signed on behalf of the Council on __________________________ by:</p>

        <div className="grid grid-cols-2 gap-8 mt-6">
          <div className="space-y-2">
            <p className="font-semibold">Name: ___________________________</p>
            <p className="font-semibold">Signature: _______________________</p>
            <p className="font-semibold">Position: Council Chairperson</p>
          </div>
          <div className="space-y-2">
            <p className="font-semibold">Name: ___________________________</p>
            <p className="font-semibold">Signature: _______________________</p>
            <p className="font-semibold">Position: Council Secretary</p>
          </div>
        </div>

        <div className="mt-6">
          <p className="font-semibold">Name: ___________________________</p>
          <p className="font-semibold">Signature: _______________________</p>
          <p className="font-semibold">Position: Director Finance</p>
        </div>
      </div>
    </div>
  );
};


const TableOfContents = () => {
  const sections = [
    "Report of the Council",
    "Statement of Responsibilities for Annual Financial Statements",
    "Independent Auditor’s Report",
    "Statement of Cash Receipts and Payments",
    "Statement of Comparison of Budget and Actual Amounts",
    "Statement of Cash Receipts and Payments for Local Government Equalization Fund",
    "Statement of Cash Receipts and Payments for Constituency Development Fund",
    "Summary of Significant Accounting Policies",
    "Notes to the Financial Statements",
  ];

  return (
    <div className="p-6">
       <hr className="border-t-2 border-slate-200 py-5" />
      <h2 className="text-xl font-bold mb-4">TABLE OF CONTENTS</h2>
      <ul className="list-decimal list-inside space-y-2">
        {sections.map((section, index) => (
          <li key={index} className="text-base text-gray-700">
            {section}
          </li>
        ))}
      </ul>
    </div>
  );
};
const ReportPage = ({currentYearData, previousYearData, startDate}) => {
  return (
    <div className="container mx-auto my-6 bg-white">
      <TableOfContents />
      <ReportOfTheCouncil />
      <BackgroundAndLocation />
      <CompositionOfTheCouncil currentYearData={currentYearData} previousYearData={previousYearData} startDate={startDate} />
      <StatementOfResponsibilities />

      <h1>
        <hr className="border-t-2 border-slate-200 py-5" />
        INDEPENDENT AUDITOR’S REPORT</h1>
      {/* Include other sections as necessary */}
    </div>
  );
};

export default ReportPage;
